module.exports = __webpack_public_path__ + "static/media/table-glowing.7d1e0851.png";